import { useMemo } from 'react';
import { printAST } from '@utils/ast';
import { video23AudioPrinters } from './spec.23video.audio.js';
import { video23Printers } from './spec.23video.video.js';
import { boxPrinters } from './spec.box.js';
import { fontPrinters } from './spec.font.js';
import { iGuideHtmlNodeJsxPrinters } from './spec.html.js';
import { imagePrinters } from './spec.image.js';
import { iGuideHtmlToAst } from './util.html-to-ast.js';

function useHTMLContent(html, args) {
  return useMemo(() => {
    if (args?.disabled) {
      return undefined;
    }
    const ast = iGuideHtmlToAst(html);
    return printAST(ast, {
      ...iGuideHtmlNodeJsxPrinters,
      ...boxPrinters,
      ...fontPrinters,
      ...video23Printers,
      ...video23AudioPrinters,
      ...imagePrinters
    });
  }, [args?.disabled, html]);
}

export { useHTMLContent };
//# sourceMappingURL=util.print-html.js.map
